import { CanActivateFn, Router } from "@angular/router";
import { inject } from "@angular/core";
import { SessionService } from "@services/session.service";

/**
 * Impide navegar a cualquier ruta protegida cuando la sesión está en conflicto.
 * Redirige siempre a /conflicto-sesion mientras el flag esté activo.
 */
export const conflictoSesionGuard: CanActivateFn = () => {
	const sesion = inject(SessionService);
	const router = inject(Router);

	if (sesion.sesionEnConflicto) {
		return router.createUrlTree(["/conflicto-sesion"]);
	}
	return true;
};
